import axios from 'axios'
import gmCrypt from 'gm-crypt'; // 导入 gm-crypt 库
import md5 from 'js-md5'
 
const service = axios.create({
	baseURL: process.env.NODE_ENV == 'development'?'':'https://v2svr.checkupcn.com/', //http://v2_svr.checkupcn.com/
	// 生产环境审核/查询偶发超过 5s，过短会进 catch 并提示“审核操作失败/查询数据失败”
	timeout: 30000
})

// request 拦截器
/* service.interceptors.request.use(
  config => {
      config.headers['Access-Control-Allow-Origin'] = '*'; // 设置允许跨域的域名，*表示所有域名都可以跨域
      return config;
    },
    error => {
      return Promise.reject(error);
    }
) */

// response 拦截器
service.interceptors.response.use(
	response => {
		//console.log('拦截响应:');
		//console.log(response);
		if(response.data.body !== ""){
			var base64str = hexToBase64(response.data.body)
			var aaa = sm4_(base64str);
			//console.log(aaa);
			response.data.data = JSON.parse(aaa);
		}
		// 绘画失效
		if(response.data.errorcode == 1004){
			sessionStorage['_token'] = "";
			sessionStorage['_login'] = 'false';
		}
		return response
	},
	error => {
		console.log(error);
		if (isRequestTimeout(error)) {
			error.userMessage = '请求超时，请稍后重试';
		} else if (error && error.response) {
			error.userMessage = '服务异常，请稍后重试';
		} else if (error && error.message) {
			error.userMessage = '网络异常，请检查网络后重试';
		}
		return Promise.reject(error);
	}
)

/**
 * 是否为请求超时
 */
function isRequestTimeout(error) {
	if (!error) {
		return false;
	}
	if (error.code === 'ECONNABORTED') {
		return true;
	}
	const msg = String(error.message || '');
	return msg.toLowerCase().indexOf('timeout') > -1;
}

/**
 * 统一提取请求失败文案（超时 / 网络 / 业务兜底）
 */
export const getRequestErrorMessage = (error, fallback = '操作失败') => {
	if (error && error.userMessage) {
		return error.userMessage;
	}
	if (isRequestTimeout(error)) {
		return '请求超时，请稍后重试';
	}
	return fallback;
};

// 封装具体的请求方法: 四种请求类型不和下面的3和4标题内容放在一起
export const get = (url, params) => {
	return service.get(url, {
		params
	});
};

/**
 * post请求
 */
export const post = (url, data) => {
	var model = Sign(url);
	var ciphertext = sm4(JSON.stringify(data));
	model.data = ciphertext;
	url = '/'+url+'_api';
	return service.post(url, model);
};

/**
 * sm4加密
 */
function sm4(str) {
	const pwdKey = "AD81B226F60110B7";
	const iiv = "CA26CB992F34997E";
	let gmCryptConfig = {
		key: pwdKey,
		iv: iiv,
		mode: "cbc",
		cipherType: "base64"
	};
	const sm4Util = new gmCrypt.sm4(gmCryptConfig);
	const base64String = sm4Util.encrypt(str);
	const buffer = Buffer.from(base64String, 'base64');
	const HexString = buffer.toString('hex');
	return HexString;
}

/**
 * sm4解密
 */
function sm4_(base64String) {
	const pwdKey = "AD81B226F60110B7";
	const iiv = "CA26CB992F34997E";
	let gmCryptConfig = {
		key: pwdKey,
		iv: iiv,
		mode: "cbc",
		cipherType: "base64"
	};
	const sm4Util = new gmCrypt.sm4(gmCryptConfig);
	const decryptedText = sm4Util.decrypt(base64String );
	return decryptedText;
}

/**
 * 签名
 */
function Sign(apiCode) {
	const API_SECRET_KEY = "DDBE747336539E78"
	var RequestContent = {
		token:sessionStorage['_token'],
		timestamp:Math.floor(Date.now() / 1000)
	}
	var temp = API_SECRET_KEY+'_'+apiCode+'_'+RequestContent.timestamp;
	RequestContent.sign = md5(temp).toUpperCase();
	return RequestContent;
}
// 将十六进制字符串转为字节数组
function hexToBytes(hex) {
    const bytes = [];
    for (let i = 0; i < hex.length; i += 2) {
        bytes.push(parseInt(hex.substr(i, 2), 16));
    }
    return bytes;
}
 
// 将字节数组转为Base64字符串
function bytesToBase64(bytes) {
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
 
// 将十六进制转为Base64
function hexToBase64(hex) {
    const bytes = hexToBytes(hex);
    return bytesToBase64(bytes);
}


export default service